import React from 'react';
import {DropdownButton, MenuItem} from 'ui';
import { bottomStyle } from 'left_side_bar/LeftSideBarStyles';
import ColorConstants from 'constants/ColorConstants';

const SupportDropdownButton = ({linkStyle}) => {
  return (
    <div style={{...bottomStyle, margin: 0, marginTop: 20}}>
      <DropdownButton
        style={{
          width: "100%",
          margin: 0,
          // zero horizontal padding so the label lines up with the other
          // sidebar items, which sit at the wrapper's 15px left padding
          padding: "6px 0",
          textAlign: "left"
        }}
        variant="link"
        noCaret
        title={<div style={{
          color: linkStyle.color,
          fontSize: linkStyle.fontSize,
          cursor: linkStyle.cursor,
          marginBottom: 0,
          marginTop: 0,
          color: ColorConstants.LIGHT_GREY
        }}>Support</div>}
        id="supportDropdown"
        dropup
      >
        <MenuItem href="http://help.delvetool.com/" target="_blank">
          Help center
        </MenuItem>
        <MenuItem href="https://delvetool.com/trainingvideos" target="_blank">
          Training videos
        </MenuItem>
        <MenuItem id="delve_help_link">
          Chat with team
        </MenuItem>
      </DropdownButton>
    </div>
  );
};

export default SupportDropdownButton;
